// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
import * as log from 'loglevel';
import messaging from 'firebase/messaging';
import firebase from 'firebase/app';
const path = require('path');

const config = {
  apiKey: 'AIzaSyCLCpyppiXURfM4yQJWI6kL5Gvu2J1YQmQ',
  authDomain: 'webee-done.firebaseapp.com',
  databaseURL: 'https://webee-done.firebaseio.com',
  projectId: 'webee-done',
  storageBucket: 'webee-done.appspot.com',
  messagingSenderId: '926867265121',
  appId: '1:926867265121:web:e3a68283ed202a38a2fc20',
  measurementId: 'G-55TVBQ62ER'
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

let fMessaging;
if (firebase.messaging.isSupported()) {
  fMessaging = firebase.messaging();
}
// try {
//   fMessaging.usePublicVapidKey(
//     "BOn3uVyw_bRVK_9-HJgSfvkcDWAdmXe64Yix7HbxrGxbxDtVNo8r8RYrGkYyHOa833D6EEpb6jcbMjLEMkfeeR4"
//   );
// }
// catch (err) {
// };

export function register(config) {
  // if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    const isLocalhost = Boolean(
      window.location.hostname.indexOf('local') > -1 ||
      // [::1] is the IPv6 localhost address.npm
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
    );

    // The URL constructor is available in all browsers that support SW.
    // const publicUrl = new URL(config.baseURL, window.location); //const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
    // if (publicUrl.origin !== window.location.origin) {
    //   // Our service worker won't work if PUBLIC_URL is on a different origin
    //   // from what our page is served on. This might happen if a CDN is used to
    //   // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
    //   return;
    // }

    // if(isLocalhost) {
    //   navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).then(function(register){
    //     let swUrl = path.join(__dirname, 'src', 'service-worker.js');
    //     registerValidSW(swUrl);
    //   }).catch(function(err){
    //   });
    // }

    window.addEventListener('load', () => {
      if (!isLocalhost) {
        let swUrl = `${window.location.href.split('webee.app')[0]}webee.app/my-service-worker.js`;
        if (window.location.href.includes('.home2nite')) {
          swUrl = `${window.location.href.split('home2nite.com')[0]}home2nite.com/my-service-worker.js`;
        }
        // Is not local host. Just register service worker
        registerValidSW(swUrl, config);
      }
      if (process.env.NODE_ENV === 'development') {
        const swUrl = `${process.env.PUBLIC_URL}/my-service-worker.js`;
        registerValidSW(swUrl, config);
      }

      // else {
      //   // const swUrl = `${window.location.href.split('webee.app:3080')[0]}webee.app:3080/service-worker.js`;
      //   // const swUrl = `${window.location.href.split('local-staff.webee.app:3080')[0]}local-staff.webee.app:3080/service-worker.js`;
      //   const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      //   // This is running on localhost. Lets check if a service worker still exists or not.
      //   registerValidSW(swUrl);
      //   //checkValidServiceWorker(swUrl);

      // }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      // try {
      //   fMessaging.useServiceWorker(registration);
      // } catch (err) {
      //   log.error('fmessagingerr:', err);
      // }
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the old content will have been purged and
              // the fresh content will have been added to the cache.
              // It's the perfect time to display a "New content is
              // available; please refresh." message in your web app.
              // alert("New content is available; please refresh.");
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
              // window.location.reload();
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              // alert("Content is cached for offline use.");
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      if (response.status === 404 || response.headers.get('content-type').indexOf('javascript') === -1) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      log.error('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
